/* eslint-disable */
const  {REACT_APP_ENV}  = process.env;
const env = process.env;
const imageCloudNameLive = 'dgcojyezg';
const imageCloudNameBeta = 'dglcrirjs';
const imageCloudNameQa = 'dfpffsf2y';
const imageCloudNameDev = 'dcevbvmdu';

const imageCloudPresetQa = 'n4lcu2tr';
const imageCloudPresetDev = 'dycthn0s';
const imageCloudPresetLive = 'hglnuurt';
const imageCloudPresetBeta = 'cw1lllrv';

const pdfTransactionsCloudNameLive = 'dgcojyezg';
const pdfTransactionsCloudNameBeta = 'dglcrirjs';
const pdfTransactionsCloudNameQa = 'dz4u73trs';
const pdfTransactionsCloudNameDev = 'dz4u73trs';
const PDF__TRANSACTIONS_PRESET = 'pdf_transaction_preset';

const cloudFolderLive = 'ms-singapore';
const cloudFolderBeta = 'ms-singapore';
const cloudFolderQae = 'ms-singapore';
const cloudFolderDev = 'ms-singapore';

const baseURLQae = 'http://3.139.180.212/';
const baseURLDev = 'http://18.188.176.75/';
const baseURLBeta = 'https://beta-api.millionspaces.com/';
// const baseURLLive = 'https://prod.millionspaces.com/';
const baseURLLive = 'https://api-dev.millionspaces.com/';

const msUrlQa = 'http://new-qae.millionspaces.com.s3-website.ap-south-1.amazonaws.com';
const msUrlDev = 'http://dev.millionspaces.com.s3-website-ap-southeast-1.amazonaws.com';
const msUrlBeta = 'https://beta.millionspaces.com';
// const msUrlLive = 'https://millionspaces.com';
const msUrlLive = 'htdeploy:ecstp://ecs.millionspaces.com.s3-website-us-east-1.amazonaws.com';

const imageCloudPathQae = `http://res.cloudinary.com/${imageCloudNameQa}/`;
const imageCloudPathDev = `http://res.cloudinary.com/${imageCloudNameDev}/`;
const imageCloudPathLive = `http://res.cloudinary.com/${imageCloudNameLive}/`;
const imageCloudPathBeta = `http://res.cloudinary.com/${imageCloudNameBeta}/`;

//----------Google API keys -------------------------
const googleApiKeyQa = 'AIzaSyBUNB7r5HwOPjhE9nFjUlSjUhd3_NaM4lk';
const googleApiKeyDev = 'AIzaSyBUNB7r5HwOPjhE9nFjUlSjUhd3_NaM4lk';
const googleApiKeyBeta = 'AIzaSyBUNB7r5HwOPjhE9nFjUlSjUhd3_NaM4lk';
const googleApiKeyLive = 'AIzaSyBUNB7r5HwOPjhE9nFjUlSjUhd3_NaM4lk';

const constructApi = (env) => `https://api-dev.millionspaces.com/api`;
// const constructApi = (env) => `https://${env}api.millionspaces.com/api/`;

let IMAGE_CLOUD_NAME = imageCloudNameDev;
let IMAGE_CLOUD_PRESET = imageCloudPresetDev;
let IMAGE_CLOUD_FOLDER = cloudFolderDev;
let baseURL = baseURLDev;
let MS_URL = msUrlDev;
let IMAGE_CLOUD_PATH = imageCloudPathDev;
let PDF__TRANSACTIONS_CLOUDE_NAME = pdfTransactionsCloudNameDev;
let api = constructApi(REACT_APP_ENV === 'qae' ? 'q' : '');
let GO0GLE_API_KEY = googleApiKeyDev;

if (REACT_APP_ENV === 'qae') {
  console.log(constructApi(REACT_APP_ENV === 'qae' ? 'q' : ''));

  IMAGE_CLOUD_NAME = imageCloudNameQa;
  IMAGE_CLOUD_PRESET = imageCloudPresetQa;
  IMAGE_CLOUD_FOLDER = cloudFolderQae;
  IMAGE_CLOUD_PATH = imageCloudPathQae;
  baseURL = baseURLQae;
  MS_URL = msUrlQa;
  PDF__TRANSACTIONS_CLOUDE_NAME = pdfTransactionsCloudNameQa;
  GO0GLE_API_KEY = googleApiKeyQa;
  MS_URL = msUrlQa;
} else if (REACT_APP_ENV === 'dev') {
  IMAGE_CLOUD_NAME = imageCloudNameDev;
  IMAGE_CLOUD_PRESET = imageCloudPresetDev;
  IMAGE_CLOUD_FOLDER = cloudFolderDev;
  IMAGE_CLOUD_PATH = imageCloudPathDev;
  baseURL = baseURLDev;
  PDF__TRANSACTIONS_CLOUDE_NAME = pdfTransactionsCloudNameDev;
  GO0GLE_API_KEY = googleApiKeyDev;
  MS_URL = msUrlDev;
} else if (REACT_APP_ENV === 'beta') {
  IMAGE_CLOUD_NAME = imageCloudNameBeta;
  IMAGE_CLOUD_PRESET = imageCloudPresetBeta;
  IMAGE_CLOUD_FOLDER = cloudFolderBeta;
  IMAGE_CLOUD_PATH = imageCloudPathBeta;
  baseURL = baseURLBeta;
  PDF__TRANSACTIONS_CLOUDE_NAME = pdfTransactionsCloudNameBeta;
  GO0GLE_API_KEY = googleApiKeyBeta;
  MS_URL = msUrlBeta;
} else if (REACT_APP_ENV === 'live') {
  IMAGE_CLOUD_NAME = imageCloudNameLive;
  IMAGE_CLOUD_PRESET = imageCloudPresetLive;
  IMAGE_CLOUD_FOLDER = cloudFolderLive;
  IMAGE_CLOUD_PATH = imageCloudPathLive;
  baseURL = baseURLLive;
  PDF__TRANSACTIONS_CLOUDE_NAME = pdfTransactionsCloudNameLive;
  GO0GLE_API_KEY = googleApiKeyLive;
  MS_URL = msUrlLive;
}

export {
  api,
  IMAGE_CLOUD_NAME,
  IMAGE_CLOUD_PRESET,
  PDF__TRANSACTIONS_PRESET,
  PDF__TRANSACTIONS_CLOUDE_NAME,
  IMAGE_CLOUD_FOLDER,
  baseURL,
  MS_URL,
  REACT_APP_ENV,
  IMAGE_CLOUD_PATH,
  GO0GLE_API_KEY,
};

// Dates
export const TIME_STRING_FORMAT = 'hh:mm A';
export const DATE_FORMAT = 'DD MMM YY';
export const CALENDAR_DATE_FORMAT = 'DD-MM-YYYY'; // Format expected by backend calendar API
export const CALENDAR_DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';
// Messages
export const googleApi = `https://maps.googleapis.com/maps/api/place/autocomplete/json`;
export const mockApi = `http://5d6f64ec482b530014d2e11e.mockapi.io/api/`;
export const countryRestrictions = 'country:sg|country:lk';
